import React, { memo } from "react";
import "./BrickGrid.css";

interface Props {
  /** One string per row; each char is a cell: '.' empty, 'g' ghost, '*' flashing, else a color key. */
  rows: string[];
  /** Cell size in px. */
  cell: number;
  /** Brick color per cell char. */
  colors: Record<string, string>;
  /** Draw the dark baseplate frame and empty-cell grid (off for small previews). */
  framed?: boolean;
  label?: string;
}

function cellClass(ch: string) {
  if (ch === ".") return "brick-cell";
  if (ch === "g") return "brick-cell brick-cell--ghost";
  if (ch === "*") return "brick-cell brick-cell--flash";
  return "brick-cell brick-cell--brick";
}

const Row = memo(function Row({ row, colors }: { row: string; colors: Record<string, string> }) {
  return (
    <div className="brick-grid__row">
      {row.split("").map((ch, i) => (
        <span
          key={i}
          className={cellClass(ch)}
          style={colors[ch] ? ({ "--brick": colors[ch] } as React.CSSProperties) : undefined}
        />
      ))}
    </div>
  );
});

/** A field of studded bricks seen from above, shared by the games and their previews. */
function BrickGrid({ rows, cell, colors, framed = true, label }: Props) {
  return (
    <div
      className={framed ? "brick-grid" : "brick-grid brick-grid--bare"}
      style={{ "--cell": `${cell}px` } as React.CSSProperties}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <div className="brick-grid__field">
        {rows.map((row, i) => (
          <Row key={i} row={row} colors={colors} />
        ))}
      </div>
    </div>
  );
}

export default BrickGrid;
